import request from 'superagent';

const REQUEST_HELP = 'REQUEST_HELP';
const REQUEST_HELP_SUCCESS = 'REQUEST_HELP_SUCCESS';
const REQUEST_HELP_FAILURE = 'REQUEST_HELP_FAILURE';

export default function reducer(state = {requesting: false, success: null}, action) {
  switch (action.type) {
    case REQUEST_HELP:
      return {...state, requesting: true};
    case REQUEST_HELP_SUCCESS:
    return {...state, success: true, requesting: false};
    case REQUEST_HELP_FAILURE:
    return {...state, success: false,  requesting: false};
    default:
      return state;
  }
}
export function requestHelp(help) {
  return dispatch => {
    dispatch({type: REQUEST_HELP})
    request
      .post('/svc/zendesk/')
      .send(help)
      .set({
          'Content-Type': 'application/json',
          'Accept': 'application/json'
      })
      .end((err, res) => {
        if (err || res.statusCode !== 200 ) {
          dispatch({type: REQUEST_HELP_FAILURE})
        } else {
          dispatch({type: REQUEST_HELP_SUCCESS})
        }
      });
  }
}


// WEBPACK FOOTER //
// ./src/modules/zendesk.js